import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SeasonPlan } from '@coin/shared/core/util-models';
import { SeasonState } from '../../../season-mgmt/store';

@Component({
  selector: 'admin-select-plan-dialog',
  templateUrl: './select-plan-dialog.component.html',
  styleUrls: ['./select-plan-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectPlanDialogComponent {
  data = inject<{
    value: SeasonPlan;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<SelectPlanDialogComponent>>(MatDialogRef);
  private seasonState = inject(SeasonState);

  plans = this.seasonState.plans;

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.data.value);
  }

  displayFn(plan: SeasonPlan): string {
    return plan.title;
  }

  compare(planOne: SeasonPlan, planTwo: SeasonPlan): boolean {
    return planOne?.id === planTwo?.id;
  }
}
